/**
 * Configuration for ALB OIDC authentication
 * Note: Client-side configuration with feature flag integration
 */
import { FEATURE_FLAGS, debugLog as featureDebugLog } from './FeatureFlags';

export interface OIDCConfig {
  enabled: boolean;
  debugMode: boolean;
}

/**
 * Client-side OIDC configuration
 * All sensitive configuration (JWT keys, issuer details) handled server-side
 * Debug mode now controlled by feature flags
 */
const getOIDCConfig = (): OIDCConfig => {
  return {
    enabled: true, // Always enabled for preview environments
    debugMode: FEATURE_FLAGS.ALLOW_OIDC_DEBUG,
  };
};

const oidcConfig = getOIDCConfig();

/**
 * Check if OIDC authentication should be enabled
 * Always enabled for preview environments, controlled server-side
 */
const isOIDCEnabled = (): boolean => {
  return oidcConfig.enabled;
};

/**
 * Debug logging utility with feature flag integration
 */
const debugLog = (message: string, data?: any): void => {
  // Use centralized feature flag logging without double [DEBUG] prefix
  if (FEATURE_FLAGS.ALLOW_OIDC_DEBUG) {
    featureDebugLog(`[OIDC] ${message}`, data || '');
  }

  // Always log OIDC errors and important events to console
  if (
    message.includes('Error') ||
    message.includes('Failed') ||
    message.includes('completed successfully')
  ) {
    console.log('[OIDC]', message, data || '');
  }
};

// Export all functions at the end of the file
export { isOIDCEnabled, debugLog };
